// the media card inset the word cloud established -- mirrors $media-inset in
// components/styles/lib.scss and CLOUD_INSET in word-cloud/constants/config.js
export const MEDIA_INSET = 10

// Marks a question's controls and a Data Lab editor as left off the printed page; the print rule lives in
// the page's global stylesheet, since the component stylesheets are linked for screen only.
export const NO_PRINT = 'stat-no-print'

export const QUESTION_TITLE_THUMB_WIDTH = 30
export const QUESTION_TITLE_THUMB_HEIGHT = 30
export const QUESTION_TITLE_IMAGE_WIDTH = 320
export const QUESTION_TITLE_IMAGE_HEIGHT = 6000
export const QUESTION_TITLE_IMAGE_MIN_WIDTH = 70
export const QUESTION_TITLE_IMAGE_MAX_WIDTH = 265
export const QUESTION_TITLE_IMAGE_MIN_HEIGHT = 70
export const QUESTION_TITLE_IMAGE_MAX_HEIGHT = 265

export const TYPE_VARIANT_MAP = {
  dlv: 'vq',
  dlc: 'cq',
  dlx: 'xq',
  dld: 'cl',
  dlt: 'tl',
  sn: 'sn'
}

export const TYPE_DND_MAP = {
  dlv: 'question-custom',
  dlc: 'question-custom-cf',
  dlx: 'question-custom-xpert',
  dld: 'question-custom-concept',
  dlt: 'question-custom-tracker',
  sn: 'question-custom-sn'
}

export const TYPE_FEATURE_MAP = {
  dlv: 'data_lab_vq',
  dlc: 'data_lab_cf',
  dlx: 'data_lab_xpert',
  dld: 'data_lab_concept',
  dlt: 'data_lab_tracker',
  sn: 'data_lab_storytelling'
}

export const TYPE_CLASS_MAP = {
  dlv: 'virtual-question',
  dlc: 'correlation-finder',
  dlx: 'xpert-question',
  dld: 'concept-question',
  dlt: 'tracker-question'
}

export const CHART_VIEW_MAPPING = {
  mx: [
    { text: 'Stacked Counts', value: 'stackedCounts', listText: 'Stacked Counts' },
    { text: 'Stacked 100%', value: 'stacked', listText: 'Stacked 100%' },
    { text: 'Means', value: 'meanScore', listText: 'Means' },
    { text: 'Box Scores', value: 'boxScore', listText: 'Box Scores' }
  ],
  sr: [
    { text: 'Stacked', value: 'stacked', listText: 'Stacked' },
    { text: 'Score average', value: 'score', listText: 'Score average' }
  ],
  se: [
    { text: 'Stacked', value: 'stacked', listText: 'Stacked' },
    { text: 'Score average', value: 'score', listText: 'Score average' }
  ],
  ro: [
    { text: 'Area', value: 'area', listText: 'Area' },
    { text: 'Stacked', value: 'stacked', listText: 'Stacked' },
    { text: 'Score average', value: 'score', listText: 'Score average' }
  ],
  aro: [
    { text: 'Area', value: 'area', listText: 'Area' },
    { text: 'Stacked', value: 'stacked', listText: 'Stacked' },
    { text: 'Score average', value: 'score', listText: 'Score average' }
  ],
  ps: [{ text: 'Score average', value: 'score', listText: 'Score average' }],
  mp: {
    radios: [
      { text: 'Stacked Counts', value: 'stackedCounts', listText: 'Stacked Counts' },
      { text: 'Stacked 100%', value: 'stacked', listText: 'Stacked 100%' },
      { text: 'Means', value: 'meanScore', listText: 'Means' },
      { text: 'Box Scores', value: 'boxScore', listText: 'Box Scores' }
    ],
    default: [{ text: 'Stacked', value: 'stacked', listText: 'Stacked' }]
  }
}

export const CHART_LABELS_MAPPING = [
  { text: 'Entities', value: 'entities', listText: 'Entities' },
  { text: 'Positions', value: 'positions', listText: 'Positions' }
]

export const HELP_OPTIONS = {
  stackedCounts:
    'The total bar height represents the base size for the question or sub-question, with each bar segment representing the number of respondents who gave the respective answer. If the base size for each question/sub-question, this view will be identical with Stacked 100% view.',

  stacked:
    'Each bar segment represents the percent of respondents who gave the respective answer.  Regardless of base size, all questions/sub-questions are scaled to 100%.',

  meanScore: 'Will show the arithmetic average score for each question/sub-question, coded as A1 = 1, A2 = 2, etc.',

  boxScore: {
    top1: 'Will show the % of respondents who answered A1 in a question or sub-question answer set.',
    top2: 'Will show the % of respondents who answered either A1 or A2 in a question or sub-question answer set.',
    top3: 'Will show the % of respondents who answered either A1, A2, or A3 in a question or sub-question answer set.',
    top2w:
      'This is a weighted calculation of the top two boxes: 100% of A1 + 50% of A2.\nExample, if 25% answered A1 and 10% answered A2, the T-weighted would equal 25 + (10/2) = 30%',
    bottom1:
      'Will show the % of respondents who answered the last option (e.g. A5 in a set of five response options) in a question or sub-question answer set.',
    bottom2:
      'Will show the % of respondents who answered either the last or second to last option (e.g. A4 or A5 in a set of five response options) in a question or sub-question answer set.',
    bottom3:
      'Will show the % of respondents who answered any of the last three options (e.g. A3, A4 or A5 in a set of five response options) in a question or sub-question answer set.',
    bottom2w:
      'This is a weighted calculation of the bottom two boxes: 100% of the last option and 50% of the second to last option. Example, if 25% answered B5 (in a five-point scale) and 10% answered B4, the B-weighted would equal 25 + (10/2) = 30%'
  }
}

export const DEFAULT_CHART_LABELS = 'entities'
export const DEFAULT_CHART_TOPS = 'top1'
export const DEFAULT_CHART_VIEW = 'stacked'

export const QUESTION_ANNOTATION_LIMIT = 9999

export const LINK_ID_REG = /^([cpvx]?q|cl|tl|sn)(\d+)(?:sq(\d+))?$/i

// The height a stats chart is drawn at unless it names its own -- the legacy chart models' default.
export const CHART_HEIGHT = 426
